/* eslint-disable class-methods-use-this */

// Apis
// GridState
// ColumnsResizing
// ColumnsOrder
// ColumnsVisibilities
// CellEvents
// ContextMenu
// PersistSortedColumn
// PersistSelectedRow
// PersistSelectedRowVisibility
// SelectionWithArrowKeys
// DefaultSelection
// StatusBarRangeSelection
// Disabling
// Loading
// AgGridTheme
// Whatever

import React from 'react'
import first from 'lodash/first'
import isFunction from 'lodash/isFunction'
import { useUpdateAtom } from 'jotai/utils'

import withLKGridInterface from './withLKGridInterface'
import { defaultProps, propTypes } from './propTypes'
import { getIconColumns } from '../store'
import { ColumnsProvider } from './ColumnsProvider'
import { GridLoadingProvier } from './GridLoadingProvier'
import Persistor from './Persistor'
import { useSetGridApi } from './gridApi'

const Index = React.memo((props) => {
  const {
    instanceName,
    iGridIdentity,
    iSyncGridState,
    iRowData,
    iColumnConfigs,
    iOnCellClicked,
    iDisabled,
    iShowCellFocus,
    iLoading,
  } = props

  const setGridApi = useSetGridApi()

  const iconColumns = getIconColumns(iColumnConfigs)

  const handleCellClicked = (params) => {
    if (!isFunction(iOnCellClicked)) {
      return
    }

    const { field } = params.column.colDef
    const columnData = iRowData.map((row) => row[field])

    iOnCellClicked(params, { columnData })
  }

  return (
    <ColumnsProvider
      instanceName={instanceName}
      form={iGridIdentity.formName}
      object={iGridIdentity.objectName}
      customID={iGridIdentity.customID}
      sync={iSyncGridState}
      iconColumns={iconColumns}
      sample={first(iRowData)}
    >
      <GridLoadingProvier iDisabled={iDisabled} iShowCellFocus={iShowCellFocus} iLoading={iLoading}>
        <Persistor {...props} onCellClicked={handleCellClicked} setGridApi={setGridApi} suppressDragLeaveHidesColumns />
      </GridLoadingProvier>
    </ColumnsProvider>
  )
})

Index.defaultProps = defaultProps
Index.propTypes = propTypes

export default withLKGridInterface(Index)
